import * as R from 'ramda';
import { connect } from 'react-redux';
import { compose, withProps, withHandlers, renameProps } from 'recompose';

import NotesList from '../../components/notes-simple-list';
import { openModal, modalNames } from '../../modals';
import { handleMeetingNoteDelete } from '../../redux/thunk/meeting-notes';

import { sortMeetingNotesByDate } from '../../utils';
import { getMeetingNotesWithCreator } from '../../redux/selectors';


const mapStateToProps = (state, props) => R.compose(
  ({ meetingNotes }) => ({
    meetingNotes: Object.keys(meetingNotes)
      .map(key => Object.assign({}, {
        ...meetingNotes[key],
        date: meetingNotes[key].meetingDate,
      })),
    contacts: state.contacts.items,
    users: state.users.items,
  }),
  ({ notes }) => ({ meetingNotes: sortMeetingNotesByDate(notes) }),
  data => ({ notes: getMeetingNotesWithCreator(data, props) }),
)(state);

export default compose(
  connect(
    mapStateToProps,
    { openModal, handleMeetingNoteDelete },
  ),
  withProps(() => ({
    noteType: 'meeting',
  })),
  renameProps({
    meetingNotes: 'notes',
  }),
  withHandlers({
    handleNoteDelete: props => (meetingNoteId) => {
      props.handleMeetingNoteDelete(meetingNoteId, props.notes.length);
    },
    openNoteModal: actions => (requestId, meetingNoteId) => {
      actions.openModal({
        name: modalNames.MEETING_NOTES,
        payload: { requestId, meetingNoteId },
      });
    },
    onNoteCreate: actions => (requestId) => {
      actions.openModal({
        payload: { requestId },
        name: modalNames.ADD_MEETING_NOTES,
        width: 900,
        isCloseIconOuter: true,
        style: {
          padding: '18px 12px',
          marginTop: '24px',
        },
      });
    },
  }),
)(NotesList);



// WEBPACK FOOTER //
// ./src/containers/meeting-notes-simple-list/index.js